<template>
	<transition name="fade">
		<div v-if="upsellModalOpen" class="modal" tabindex="-1" ref="upsellModal">
			<div class="modal-dialog modal-lg">
				<div class="modal-content px-2">
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12 col-sm-6">
                                <div class="row py-2 column-title current">
                                    <b class="d-block">Current Selection</b>
                                </div>
                                <div class="row row-mh">
                                    <div class="col-6">
                                        <img :src="currentTyreBrandImagePath" class="img-fluid" :alt="currentTyre.brand + ' logo'" @error="replaceOnError" />
                                        <b class="d-block mt-2">{{ currentTyre.brand }}</b>
                                        <p class="mb-0">{{ currentTyre.pattern }}</p>
                                        <p class="mb-0">{{ currentTyre.size }} {{ currentTyre.load_speed }}</p>
                                        <b class="d-block">&pound;{{ currentTyre.retail}}</b>
                                        <small class="d-block">per tyre</small>
                                    </div>
                                    <div class="col-6">
                                        <div class="img-wrap">
                                            <img :src="imageBasePath + currentTyre.graphic" class="img-fluid" :alt="currentTyre.brand + currentTyre.pattern + ' image'" @error="replaceTyreOnError"/>
                                        </div>
                                        <rating-labels :fuel="currentTyre.fuel" :wet="currentTyre.wet" :decibels="currentTyre.decibels" :noise-rating="currentTyre.noise_rating"></rating-labels>
                                    </div>
                                </div>
                                <hr>
                                <button class="d-block btn btn-secondary w-100" @click="this.addToBasket(currentTyre.st_code, currentTyre.quantity, false)">I'll keep my choice</button>
                            </div>
                            <div class="col-12 col-sm-6 mt-4 mt-sm-0">
                                <div class="row bg-secondary py-2 column-title recommended">
                                    <b class="d-block text-white">Recommended Tyre</b>
                                </div>
                                <div class="row row-mh">
                                    <div class="col-6">
                                        <img :src="upsoldTyreBrandImagePath" class="img-fluid" :alt="upsoldTyre.brand + ' logo'" />
                                        <b>{{ upsoldTyre.brand }}</b>
                                        <p class="mb-0">{{ upsoldTyre.pattern }}</p>
                                        <p class="mb-0">{{ upsoldTyre.size }} {{ upsoldTyre.load_speed }}</p>
                                        <b class="d-block">&pound;{{ upsoldTyre.retail}}</b>
                                        <small class="d-block">per tyre</small>
                                    </div>
                                    <div class="col-6">
                                        <div class="img-wrap">
                                            <img :src="imageBasePath + upsoldTyre.graphic" class="img-fluid" :alt="upsoldTyre.brand + upsoldTyre.pattern + ' image'" />
                                        </div>
                                        <rating-labels :fuel="upsoldTyre.fuel" :wet="upsoldTyre.wet" :decibels="upsoldTyre.decibels" :noise-rating="upsoldTyre.noise_rating"></rating-labels>
                                    </div>
                                </div>
                                <div v-if="upsellDetails.short_description" class="col-12 bg-warning p-2 mt-3">
                                    <p v-html="upsellDetails.short_description"></p>
                                </div>
                                <div v-if="upsellDetails.description" class="col-12 bg-darker-blue p-2 mt-3">
                                    <p v-html="upsellDetails.description"></p>
                                </div>
                                <button class="btn btn-primary w-100 green-bg mt-3" @click="this.addToBasket(upsoldTyre.st_code, upsoldTyre.quantity, true)" v-html="upsellDetails.submit_button_text"></button>
                            </div>
                        </div>
                    </div>
				</div>
			</div>
		</div>
	</transition>
</template>
<script>
    export default {
        props: ['currentTyre', 'upsoldTyre', 'upsellDetails', 'upsellModalOpen', 'imageBasePath'],
        data() {
            return {
            }
        },
        mounted() {
        },
        methods: {
            addToBasket(st_code, quantity, accepted) {
                this.$parent.addTyreToBasket(st_code, quantity);
                if(typeof(this.$gtag) !== 'undefined') {
                    this.$gtag.event('Tyre Upsell', {
                        'event_category': 'Upsell ' + (accepted == true ? 'Accepted' : 'Rejected'),
                        'event_label': (accepted == true ? 'accepted' : 'rejected'),
                        'value': this.upsellDetails.id
                    });
                }
                else {
                    console.log('gtag not loaded');
                }
            },
            replaceOnError(e) {
                e.target.src = this.imageBasePath + 'brand_logos/generic.png'; 
            },
            replaceTyreOnError(e) {
                e.target.src = this.imageBasePath + 'coming_soon.png'; 
            },
        },
        computed: {
            currentTyreBrandImagePath() {
                return (this.imageBasePath + 'brand_logos/' + (this.currentTyre.brand_image != null ? this.currentTyre.brand_image : 'generic.png'));
            },
            upsoldTyreBrandImagePath() {
                return (this.imageBasePath + 'brand_logos/' + (this.upsoldTyre.brand_image != null ? this.upsoldTyre.brand_image : 'generic.png'));
            }
        }
    }
</script>
<style lang="scss" scoped>
    .error {
        color: red;
    }
    .modal {
		background-color: rgba(0,0,0,.5);
	  	display: block;
        .img-wrap {
            max-height: 70px;
            overflow: hidden;
            margin-bottom: 10px;
        }
        .column-title {
            @media screen and (min-width: 768px) {
                margin-top: -16px;
            }
            margin-bottom: 10px;
            text-align: center;
            &.current {
                border-top-left-radius: 4px;
                background: #d8d8d8;
                color: #424242;
                @media screen and (min-width: 768px) {
                    margin-left: -24px;
                }
            }
            &.recommended {
                border-top-right-radius: 4px;
                @media screen and (min-width: 768px) {
                    margin-right: -24px;
                }
            }
        }
        .bg-darker-blue {
            background-color: #005eb8;
            color: #fff;
        }
	}
</style>